import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/main.css';
import './styles/pages.css';
import './styles/home.css';
import './styles/match.css';
import './styles/inner.css';
import './styles/more.css';
import './styles/contact.css';
import './styles/team.css';
import './styles/home2.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
